import type { Layout } from "@motain/xpa-proto-files-web/lib/types/xpa";
import { MIN_IN_MS } from "@/constants/date-ago";
import { isNullable } from "@/types/isNullable";
import {
  LIVE_MATCH_PERIODS,
  POST_MATCH_PERIODS,
} from "@/xpa-components/match-score/constants";

import { getMatchScoreFromLayout } from "./get-match-score-from-layout";
import { getPreMatchDelay } from "./get-pre-match-delay";

interface Response {
  delay?: number;
  interval?: number;
}

const STOPPED_POLLING_CONFIG: Response = {
  delay: undefined,
  interval: undefined,
};
const LIVE_MATCH_POLLING_CONFIG: Response = {
  delay: 30_000,
  interval: 30_000,
};

export const getPollingConfig = (layout: Layout): Response => {
  const matchScore = getMatchScoreFromLayout(layout);

  if (isNullable(matchScore)) {
    return STOPPED_POLLING_CONFIG;
  }

  if (LIVE_MATCH_PERIODS.includes(matchScore.period)) {
    return LIVE_MATCH_POLLING_CONFIG;
  }

  if (POST_MATCH_PERIODS.includes(matchScore.period)) {
    return STOPPED_POLLING_CONFIG;
  }

  const kickoffTime = matchScore.kickoff?.utcTimestamp;

  if (isNullable(kickoffTime)) {
    return STOPPED_POLLING_CONFIG;
  }

  const delay = getPreMatchDelay({
    currentTime: new Date(),
    kickoffTime: new Date(kickoffTime),
  });

  return {
    delay,
    interval: 1 * MIN_IN_MS,
  };
};
